import React from 'react';
import { Paper, Box, Typography } from '@mui/material';

export default function KpiCard({ icon, label, value, accent, subtext }) {
    return (
        <Paper
            sx={{
                p: 2.5,
                borderRadius: '16px',
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)',
                borderLeft: `4px solid ${accent}`,
                bgcolor: '#fff',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 0.5,
            }}
        >
            <Box display="flex" alignItems="center" gap={1}>
                <Box
                    sx={{
                        width: 36,
                        height: 36,
                        borderRadius: '10px',
                        bgcolor: `${accent}1A`,
                        color: accent,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {icon}
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
                    {label}
                </Typography>
            </Box>
            <Typography variant="h4" sx={{ fontWeight: 700, mt: 1 }}>
                {value}
            </Typography>
            {subtext && (
                <Typography variant="caption" color="text.secondary">
                    {subtext}
                </Typography>
            )}
        </Paper>
    );
}
